import { useSuspenseQuery } from '@tanstack/react-query';
import { SourcingService } from 'api-clients/monolith';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Counter } from '@/components/ui/counter';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';
import { queryKeys } from '@/query-keys';

import { ContractsTable } from './table';

/* Layout component with all static content, to avoid code duplication in skeleton */
function ContractsListLayout({
  children,
  counter,
}: {
  children: ReactNode;
  counter: ReactNode;
}) {
  return (
    <div className="border-fx-neutral-200 flex flex-col rounded-md border bg-white">
      <div className="flex items-center justify-between p-4">
        {/* Title and description */}
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <Typography variant="medium2" as="h2">
              <FormattedMessage
                defaultMessage="Active Contracts"
                description="Title for the active contracts"
              />
            </Typography>
            {counter}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}

export function ContractsList() {
  const {
    data: { contracts },
  } = useSuspenseQuery({
    queryKey: [...queryKeys.settings.contracts.vonqContracts],
    queryFn: () => SourcingService.getInternalApiSourcingVonqContracts(),
  });

  const contractsCount = contracts.length;

  return (
    <ContractsListLayout
      counter={contractsCount > 0 && <Counter count={contractsCount} />}
    >
      <ContractsTable contracts={contracts} />
    </ContractsListLayout>
  );
}

ContractsList.Skeleton = function ContractsListSkeleton() {
  return (
    <ContractsListLayout
      counter={<Skeleton className="h-4 w-6 rounded-full" />}
    >
      <ContractsTable.Skeleton />
    </ContractsListLayout>
  );
};
